// extracted by mini-css-extract-plugin
export default {"root":"AuthModal__root--2TMaI","buttonWrapper":"AuthModal__buttonWrapper--3UQQC"};